import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import store from "@wptb/external/store";
import { Provider } from "@wptb/external/react-redux";
import { createRoot } from "@wptb/external/react-dom/client";
import { StrictMode } from "@wptb/external/react";
import { BuilderApp, Notifications } from "@wptb/external/components";
import type { SaveTableResponse } from "@wptb/dev/types";

interface BuilderProps {
  onSave: (data: SaveTableResponse) => void;
  onClose: () => void;
}

const BuilderPage = ({ onSave, onClose }: BuilderProps) => {
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!elRef.current) {
      return;
    }
    const root = createRoot(elRef.current);
    root.render(
      <StrictMode>
        <Provider store={store}>
          <BuilderApp onSave={onSave} onClose={onClose} isLoaded />
          <Notifications />
        </Provider>
      </StrictMode>
    );
    return () => {
      root.unmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elRef.current, onSave, onClose]);

  return createPortal(
    <div className="wptb-builder-modal">
      <div className="wptb-app-root" ref={elRef} />
    </div>,
    document.body
  );
};

export default BuilderPage;
